import { translate as $t } from '@/assets/languages'
import { Loading } from 'element-ui'
import _ from 'lodash'

let needLoadingRequestCount = 0
let loading

function startLoading() {
  loading = Loading.service({
    target: document.body,
    lock: true,
    text: 'loading',
    spinner: 'el-icon-loading',
    color: 'rgba(255,255,255,0.5)',
    background: 'rgba(0, 0, 0, 0.1)'
  })
}
function endLoading() {
  loading.close()
}

const tryCloseLoading = () => {
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

export function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    // 创建一个 debounced（防抖动）函数，该函数会从上一次被调用后，延迟 wait 毫秒后调用 func 方法
    _.debounce(tryCloseLoading, 300)()
  }
}



// WEBPACK FOOTER //
// ./src/utils/loading.js